import React from 'react';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import IconMessageColumn from '../../../components/columns/icon-message-column';
import Global from '../../../store/global-selectors';

import { messages } from '../messages';

const shipmentNotificationToState = {
  NotSent: 'empty',
  Sent: 'normal',
  Error: 'error',
};

const ShipmentNotification = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId }));
  if (!fulfillment) {
    return null;
  }
  const shipmentNotification = fulfillment.shipmentEmailNotification?.status ?? 'NotSent';
  const shipmentEmailErrorMessage = fulfillment.shipmentEmailNotification?.errorMessage ?? null;
  const tooltipMessage = shipmentEmailErrorMessage || <FormattedMessage {...messages.shipmentNotification} />;
  return (
    <IconMessageColumn
      icon={faPaperPlane}
      message={<FormattedMessage {...messages.sent} />}
      state={shipmentNotificationToState[shipmentNotification]}
      tooltipMessage={tooltipMessage}
    />
  );
};

ShipmentNotification.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const shipmentNotification = {
  getMessageDescriptor: () => messages.shipmentNotification,
  name: <FormattedMessage {...messages.shipmentNotification} />,
  id: 'shipmentNotification',
  render: (data) => <ShipmentNotification fulfillmentId={data.id} />,
};
